<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="createdUserName" label="记录人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="ownerDeptName" label="所属科室">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="createdUserTitle" label="职称">
                <el-input disabled v-model="form.createdUserTitle"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="记录时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item prop="patientNo" label="住院号">
                <el-select v-model="form.patientNo" placeholder="请选择" :disabled="!editMode" filterable :filter-method="getPatientDetailList" @change="patientChange" style="width:100%">
                  <el-option v-for="item in STATIC_PatientDetails" :key="item.id" :label="item.no" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="patientName" label="患者姓名">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="patientSexName" label="性别">
                <el-input disabled v-model="form.patientSexName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="patientAge" label="年龄">
                <el-input disabled v-model="form.patientAge"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="happenTime" label="发生时间">
                <el-date-picker v-model="form.happenTime" :disabled="!editMode" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="发生时间" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productUser" label="使用人">
                <el-select v-model="form.productUserName" placeholder="请选择" :disabled="!editMode" filterable :filter-method="getUsers" @change="productUserChange" style="width:100%">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productUserDeptName" label="科室">
                <el-input disabled v-model="form.productUserDeptName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="result" label="事件后果">
                <el-select v-model="form.result" placeholder="请选择" :disabled="!editMode" style="width:100%">
                  <el-option v-for="item in ResultOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="qualitative" label="定性">
                <el-select v-model="form.qualitative" placeholder="请选择" :disabled="!editMode" style="width:100%">
                  <el-option v-for="item in QualitativeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainPerformance" label="主要表现">
                <el-input :disabled="!editMode" type="textarea" :rows="3" v-model="form.mainPerformance"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="process" label="事件经过">
                <el-input :disabled="!editMode" type="textarea" placeholder="耗材使用时间、使用目的、使用依据、使用情况、采取的治疗措施等使用情况" :rows="3" v-model="form.process"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">产品明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="productName" label="产品" width="180">
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="scope.row.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList" @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specName" label="产品规格" width="180"></el-table-column>
            <!-- <el-table-column prop="brand" label="品牌" width="100"></el-table-column> -->
            <el-table-column prop="number" label="数量" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="包装单位" width="100"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="供应商" width="180"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入批次号" v-model="scope.row.batch"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="manufactureDate" label="生产日期" width="160">
              <template slot-scope="scope">
                <el-date-picker :disabled="!editMode" v-model="scope.row.manufactureDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="160">
              <template slot-scope="scope">
                <el-date-picker :disabled="!editMode" v-model="scope.row.validityDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入序列号" v-model="scope.row.serialNo"></el-input>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="onlineNo" label="挂网号" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
            <el-table-column prop="remark" label="备注" width="180">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetBadEventById, SaveBadEvent, RejectBadEvent, GetSupplierProducts
} from "@/api";
import { QualitativeOptions, ResultOptions } from "@/enum";
import SelectTable from "@/components/select-table";
// import SelectScrollTable from "@/components/select-scroll-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    // SelectScrollTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetBadEventById,
      SaveDataAction: SaveBadEvent,
      reject: RejectBadEvent,
      form: {},

      QualitativeOptions: QualitativeOptions,
      ResultOptions: ResultOptions,

      GetSupplierProducts: GetSupplierProducts,
      rules: {
        supplierName: [
          { required: true, message: '请选择供应商', trigger: 'blur' }
        ],
      },

      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      editMode: false,
      showWorkFlowInfo: false,

      billRegisterList: [],

      productQuery: {
        status: 2
      }
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getUsers('')
    this.getProductList('')
    this.getPatientDetailList('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);


      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.form.details) {
          for (let i = 0; i < this.form.details.length; i++) {
            if (this.form.details[i].thisPaymentAmount > this.form.details[i].unPaymentAmount) {
              this.$my_message(`第${i + 1}行本次付款金额大于未付款金额`, 'warning')
              return
            }
          }
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        state: 0,
        supplierName: '',
        supplierId: '',
        details: [],
        totalAmount: 0,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        createdUserTitle: this.userInfo.title,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.form.details.push(this.childForm)
      this.autoTotalAmount()

    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        "productId": '',
        "specId": '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        "price": 0,
        "amount": 0,
        "remark": "",
      };
    },
    amountChange (row) {
      this.autoTotalAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        totalAmount = totalAmount * 1 + element.thisPaymentAmount * 1;
      });
      this.form.totalAmount = totalAmount
    },

    // change event 
    patientChange (val) {
      var arr = this.STATIC_PatientDetails.filter(e => e.id == val)
      this.form.patientId = arr[0].id
      this.form.patientNo = arr[0].no
      this.form.patientName = arr[0].name
      this.form.patientSex = arr[0].sex
      this.form.patientSexName = arr[0].sexName
      this.form.patientAge = this.jsGetAge(arr[0].birthday)// arr[0].age
    },
    productUserChange (val) {
      var arr = this.STATIC_Users.filter(e => e.id == val)
      this.form.productUser = arr[0].id
      this.form.productUserName = arr[0].name
      this.form.productUserDeptId = arr[0].deptId
      this.form.productUserDeptName = arr[0].deptName
    },
    productChange (row, val) {
      let id = row.id
      row = Object.assign(row, val)// this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      row.id = id
      row.supplierProductId = val.id
      row.number = 1
      row.price = row.purchasePrice
      row.amount = row.price * row.number
      row.remark = ''
    },

    getProductList (keyWord) {
      var query = {
        keyWord: keyWord,
        status: 2
      }

      // query.pageSize = 50
      // query.status = 2
      // query.pageIndex = 1

      this.getSupplierProducts(query)
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
